module.exports = __webpack_public_path__ + "static/media/menu-focused.62e2b949.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/menu-focused.svg
// module id = 414
// module chunks = 0